export default "__VITE_ASSET__D$gMAbKO__"